// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: XI-q-Su25C

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";
import Select from "../../Select"; // plasmic-import: F3T2BVWTbRA/component
import Select__Option from "../../Select__Option"; // plasmic-import: oWml05X-K1B/component

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicDropdown.module.css"; // plasmic-import: XI-q-Su25C/css

createPlasmicElementProxy;

export type PlasmicDropdown__VariantMembers = {};
export type PlasmicDropdown__VariantsArgs = {};
type VariantPropType = keyof PlasmicDropdown__VariantsArgs;
export const PlasmicDropdown__VariantProps = new Array<VariantPropType>();

export type PlasmicDropdown__ArgsType = {};
type ArgPropType = keyof PlasmicDropdown__ArgsType;
export const PlasmicDropdown__ArgProps = new Array<ArgPropType>();

export type PlasmicDropdown__OverridesType = {
  root?: p.Flex<"div">;
  select?: p.Flex<typeof Select>;
};

export interface DefaultDropdownProps {
  className?: string;
}

const $$ = {};

function PlasmicDropdown__RenderFunc(props: {
  variants: PlasmicDropdown__VariantsArgs;
  args: PlasmicDropdown__ArgsType;
  overrides: PlasmicDropdown__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "select.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "value2"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root
      )}
    >
      <Select
        data-plasmic-name={"select"}
        data-plasmic-override={overrides.select}
        aria-label={"Sorting Mode Selection"}
        aria-labelledby={""}
        className={classNames("__wab_instance", sty.select)}
        name={""}
        onChange={(...eventArgs) => {
          p.generateStateOnChangeProp($state, ["select", "value"])(
            eventArgs[0]
          );
        }}
        placeholder={
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__yk8XB
            )}
          >
            {"Select\u2026"}
          </div>
        }
        value={p.generateStateValueProp($state, ["select", "value"])}
      >
        <Select__Option
          className={classNames("__wab_instance", sty.option__d6I8R)}
          textValue={"Recent"}
          value={"Recent"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__nIk34
            )}
          >
            {"Newest"}
          </div>
        </Select__Option>
        <Select__Option
          className={classNames("__wab_instance", sty.option__idOrc)}
          textValue={"Random"}
          value={"Random"}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__o9FjV
            )}
          >
            {"Random"}
          </div>
        </Select__Option>
      </Select>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "select"],
  select: ["select"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  select: typeof Select;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicDropdown__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicDropdown__VariantsArgs;
    args?: PlasmicDropdown__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicDropdown__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicDropdown__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDropdown__ArgProps,
          internalVariantPropNames: PlasmicDropdown__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDropdown__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDropdown";
  } else {
    func.displayName = `PlasmicDropdown.${nodeName}`;
  }
  return func;
}

export const PlasmicDropdown = Object.assign(
  // Top-level PlasmicDropdown renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    select: makeNodeComponent("select"),

    // Metadata about props expected for PlasmicDropdown
    internalVariantProps: PlasmicDropdown__VariantProps,
    internalArgProps: PlasmicDropdown__ArgProps
  }
);

export default PlasmicDropdown;
/* prettier-ignore-end */
